import { NgModule } from '@angular/core';
import { RouterModule, Routes, CanActivate, Resolve } from '@angular/router';
import { JoinFormComponent } from './pages/join-form/join-form.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { VouchersComponent } from './pages/vouchers/vouchers.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { AuthGuardService } from './services/guards/auth-guard.service';
import { VoucherCategoryGuardService } from './services/guards/voucher-category-guard.service';
import { VenueSettingResolveService } from './services/guards/venue-setting-resolve.service';
import { VouchersVenueSettingResolveService } from './services/guards/vouchers-venue-setting-resolve.service';

const routes: Routes = [
  {
    path: 'join', component: JoinFormComponent,
    canActivate: [AuthGuardService],
    resolve: {
      venueSettings:VenueSettingResolveService
    }
  },
  {
    path: 'vouchers/:cate', component: VouchersComponent,
    canActivate: [AuthGuardService, VoucherCategoryGuardService],
    resolve: {
      venueSettings:VouchersVenueSettingResolveService
    }
  },
  // { path: 'gift', component: GiftCertComponent },
  { path: '404', component: NotFoundComponent },
  // { path:'', redirectTo: '/dashboard', pathMatch: 'full' },
  { path: '**', redirectTo: '/404' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [
    RouterModule
  ],
  providers: [
    AuthGuardService,
    VoucherCategoryGuardService,
    VenueSettingResolveService,
    VouchersVenueSettingResolveService
  ]

})
export class AppRoutingModule { }
